import React from 'react';
import { useSelector } from 'react-redux';

import PlayerOverlay from 'components/pages/playback/PlayerOverlay';
import AreYouStillWatching from 'components/pages/AreYouStillWatching';

import type { VideoCtvRedux } from 'store-types';

import PlayerFunnel from './PlayerFunnel';
import PlayerResource from './PlayerResource';
import Player from './Player';
import DRMProvider from './DRMProvider';

interface PlaybackPageProps {
  videoId?: string | null;
  rowId?: string | null;
  isAutoplay?: boolean;
  isDiscoveryRowVideo?: boolean;
  onVideoCompleted?: () => void;
  onError?: (error: unknown) => void;
  onPrevVideo?: () => void;
  onNextVideo?: () => void;
}

const PlaybackPage = ({
  videoId = null,
  rowId = null,
  isAutoplay = false,
  isDiscoveryRowVideo = false,
  onVideoCompleted = () => null,
  onError = () => null,
  onPrevVideo = () => null,
  onNextVideo = () => null,
}: PlaybackPageProps) => {
  const isCcEnabled = useSelector((state: VideoCtvRedux) => state.closedCaptioning);

  return (
    <>
      <PlayerFunnel
        videoId={videoId}
        rowId={rowId}
        isDiscoveryRowVideo={isDiscoveryRowVideo}
        onError={onError}
        render={({
          videoToPlay,
          videoToDisplay,
          isGTAutoplay,
          row,
          authorizedProvider,
          loading: authLoading,
          onPlaybackError,
          onSetResource,
        }) => (
          <PlayerResource
            videoToPlay={videoToPlay}
            videoToDisplay={videoToDisplay}
            row={row}
            isAutoplay={isAutoplay || isGTAutoplay}
            authorizedProvider={authorizedProvider}
            onError={onError}
            render={({ resource, loading: resourceLoading }) => (
              <DRMProvider
                onError={onError}
                resource={resource}
                video={videoToPlay}
                render={({ resource: resourceWithDRM }) => {
                  return (
                    <Player
                      resource={resourceWithDRM}
                      onPlaylistComplete={onVideoCompleted}
                      onError={onPlaybackError}
                      isCcEnabled={isCcEnabled}
                      loading={authLoading || resourceLoading}
                      onResourceSet={onSetResource}
                      id={videoId as string | undefined}
                      inFocus
                    />
                  );
                }}
              />
            )}
          />
        )}
      />
      <PlayerOverlay onPrevVideo={onPrevVideo} onNextVideo={onNextVideo} />
      <AreYouStillWatching />
    </>
  );
};

export default PlaybackPage;
